export default "__VITE_ASSET__dbbe4fd8__"